<template>
    <div>
        <v-alert dense border="bottom" type="primary" icon="mdi-information"
            >CASE INFORMATION</v-alert
        >
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-textarea
                            v-model="information.case_title"
                            label="Case Title / Symptom"
                            filled
                            height="80"
                            outlined
                            :rules="casetitleRules"
                            required
                        ></v-textarea>
                        <v-textarea
                            v-model="information.remark"
                            label="Remark"
                            filled
                            height="100"
                            outlined
                        ></v-textarea>
                        <v-textarea
                            v-if="
                                condition.project == 'CDAX' ||
                                    condition.project == 'SRFR'
                            "
                            v-model="information.subcase_title"
                            label="อาการเสีย"
                            filled
                            height="30"
                            outlined
                            required
                        ></v-textarea>
                        <!-- <v-textarea
                v-if="information.cdax_log !== null && information.cdax_log !== undefined"
                v-model="information.cdax_log.log"
                label="CDAX LOG"
                filled
                height="147"
                outlined
            ></v-textarea>-->
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-select
                            @change="getCEBenchO()"
                            :items="jobtype"
                            v-model="information.case_type"
                            label="Jobtype"
                            dense
                            outlined
                            :rules="jobtypeRules"
                        ></v-select>
                        <v-select
                            :items="information.problem_type"
                            item-text="problem_type_name"
                            item-value="problem_type_id"
                            v-model="information.case_problem_type"
                            label="Problem Type"
                            dense
                            outlined
                            :rules="[(v) => !!v || 'ProblemType is required']"
                        ></v-select>
                        <v-select
                            v-if="condition.team == 'NONHP'"
                            :items="CSR"
                            label="CSR"
                            v-model="information.case_csr"
                            dense
                            outlined
                        ></v-select>
                        <v-text-field
                            v-if="condition.team == 'NONHP'"
                            label="Refer Case"
                            v-model="information.case_refer"
                        ></v-text-field>
                        <v-text-field
                            v-if="
                                condition.team == 'NONHP' &&
                                    information.is_special == 'Y'
                            "
                            label="HP Case"
                            v-model="information.case_hp"
                        ></v-text-field>
                        <v-radio-group
                            v-if="condition.project == 'CDAX'"
                            v-model="chk_quotation"
                            row
                        >
                            <v-radio
                                label="ไม่มีใบเสนอราคา"
                                value="N"
                            ></v-radio>
                            <v-radio label="มีใบเสนอราคา" value="Y"></v-radio>
                        </v-radio-group>

                        <v-select
                            v-if="chk_quotation == 'Y'"
                            label="สถานะใบ quotation"
                            v-model="information.quotation_check"
                            dense
                            outlined
                            :items="quotation"
                        ></v-select>

                        <v-radio-group
                            :rules="
                                information.case_hp &&
                                (information.case_hp != '' ||
                                    information.case_hp != undefined)
                                    ? caseTypeR
                                    : ''
                            "
                            v-if="
                                condition.team == 'NONHP' &&
                                    information.is_special == 'Y'
                            "
                            v-model="information.case_hptype"
                            row
                        >
                            <v-radio label="Claim" value="Claim"></v-radio>
                            <v-radio label="Onsite" value="Onsite"></v-radio>
                            <v-radio
                                label="Software"
                                value="Software"
                            ></v-radio>
                        </v-radio-group>
                        <v-radio-group
                            v-if="condition.team != 'NONHP'"
                            v-model="information.warranty_type"
                            row
                        >
                            <v-radio label="In Waranty" value="IW"></v-radio>
                            <v-radio label="Out Waranty" value="OOW"></v-radio>
                        </v-radio-group>
                        <v-checkbox
                            v-if="condition.team == 'SVC'"
                            v-model="information.send_bkk"
                            label="Send To Bkk"
                        ></v-checkbox>
                        <v-checkbox
                            v-if="
                                condition.team == 'Bench' &&
                                    send_status !== null
                            "
                            v-model="information.send_uc"
                            label="Send To UC"
                        ></v-checkbox>
                        <v-select
                            v-if="information.case_type == 'benchO'"
                            label="CE Owner Case"
                            v-model="information.ce_bencho"
                            dense
                            outlined
                            :items="engineer"
                            item-text="emp_name_en"
                            item-value="emp_id"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-select
                            :items="SLA"
                            label="SLA"
                            v-model="information.case_sla"
                            dense
                            outlined
                            :rules="caseSLARules"
                            required
                        ></v-select>
                        <v-menu
                            v-model="datemenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="computedDateFormatted"
                                    label="Date SLA"
                                    hint="MM/DD/YYYY format"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="date"
                                no-title
                                @input="datemenu = false"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                            ref="menu"
                            v-model="timemenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="information.case_sla_time"
                                    label="Time SLA"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="timemenu"
                                v-model="information.case_sla_time"
                                full-width
                                format="24HR"
                                @click:minute="$refs.menu.save(time)"
                            ></v-time-picker>
                        </v-menu>
                        <br />

                        <v-select
                            :items="special"
                            label="Special Status"
                            v-model="information.special_status"
                            dense
                            outlined
                            required
                        ></v-select>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>
<script>
import axios from "axios"

export default {
    props: ["information", "condition"],
    //   mounted() {
    //     this.$refs.form.validate();
    //   },
    beforeMount() {
        this.SLA =
            (this.condition.team == "NONHP" ||
                localStorage.role_name != "MPS") &&
            this.information.sla_new !== undefined &&
            this.information.sla_new.length > 0
                ? [...this.information.sla_new]
                : [
                      "2 Hours",
                      "3 Hours",
                      "4 Hours",
                      "5 Hours",
                      "6 Hours",
                      "8 Hours",
                      "12 Hours",
                      "24 Hours",
                      "48 Hours",
                      "NCD",
                      "NBD",
                      "3 Days",
                  ]

        var chkteam = ["ODM", "Uc", "BKK"]
        this.chk_quotation = "N"
        this.information.quotation_check = ""
        if (this.condition.team == "NONHP") {
            this.information.case_type = "Onsite Repair"
            this.information.case_csr = "C"
        } else if (chkteam.indexOf(this.condition.team) != -1) {
            if (this.information.special_type == "Claim") {
                this.information.case_type = "Claim"
            } else if (this.information.special_type == "Software") {
                this.information.case_type = "Software"
            } else {
                this.information.case_type = "Onsite Repair"
            }
        } else if (
            this.condition.team == "SVC" ||
            this.condition.team == "Bench"
        ) {
            this.information.case_type = "bench"
        }
        if (this.information.case_sla == "" && this.condition.team != "NONHP") {
            this.information.case_sla = "NBD"
        }
        if (
            this.condition.status != "editcase" &&
            this.information.case_id[0] == "B"
        ) {
            this.information.case_problem_type = "3"
        } else if (
            this.condition.status != "editcase" &&
            this.information.case_id[0] != "B"
        ) {
            this.information.case_problem_type = "4"
        }

        this.information.warranty_type =
            this.information.otc_code == "01-Trade" ? "OOW" : "IW"
        this.information.case_hp = ""
    },
    watch: {
        // whenever question changes, this function will run
        "information.case_title": function(newQuestion, oldQuestion) {
            if (this.information.case_sla_datetime === null) {
                this.information.case_sla_time = "00:00"
            } else {
                var text = this.information.case_sla_datetime.split(" ")
                this.date = this.formatDate(text[0])
                this.information.case_sla_time = text[1].substring(0, 5)
            }
        },
    },
    data() {
        return {
            jobtype: ["Onsite Repair", "bench", "benchO", "Claim", "Software"],
            Probtype: [],
            CSR: ["A", "B", "C"],
            quotation: ["Pending", "Approved", "Rejected"],
            special: ["CRT", "update warranty"],
            SLA: [],
            date: new Date().toISOString().substr(0, 10),
            time: null,
            timemenu: false,
            datemenu: false,
            casetitleRules: [(v) => !!v || "CaseTitle is required"],
            jobtypeRules: [(v) => !!v || "CaseTitle is required"],
            caseSLARules: [(v) => !!v || "SLA is required"],
            caseTypeR: [(v) => !!v || "Case Type is required"],
            snackbar: true,
            engineer: [],
            chk_quotation: "",
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split("-")
            return `${year}-${month}-${day}`
        },
        async getCEBenchO() {
            if (this.information.case_type == "benchO") {
                const url = `${process.env.VUE_APP_ROOT_API}/api/engineer-list`
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                }
                const { data } = await axios.get(`${url}`, options)
                this.engineer = data
            }
        },
    },
    computed: {
        computedDateFormatted() {
            this.information.case_sla_date = this.formatDate(this.date)
            return this.information.case_sla_date
        },
        // computedLog() {
        //   const textshow =
        //     this.information.cdax_log.log !== undefined
        //       ? this.information.cdax_log.log
        //       : this.information.cdax_log;
        //   return textshow;
        // },
    },
}
</script>
<style scoped>
.v-snack__wrapper {
    min-width: 290px !important;
    max-width: 672px !important;
}</style
>>
